<template>
    <div style="width:90%">
        <div class="container_body">
            <header class="header_nav">
                <el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
                    <el-form-item label="设置Key" class='tiny'>
                        <el-input style="width: 200px;" v-model="searchInfo.settingKey" placeholder="请输入设置Key">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="设置名称" class='tiny'>
                        <el-input style="width: 200px;" v-model="searchInfo.settingName" placeholder="请输入设置名称">
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <template>
                            <el-button type="primary" @click="search">查询</el-button>
                            <el-button @click="empty">清空</el-button>
                            <!-- <el-button type="primary" @click="editialogVisible()">新增用户
                            </el-button> -->
                        </template>
                    </el-form-item>
                </el-form>
            </header>
        </div>

        <el-table :data="list.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
            <el-table-column prop="id" label="序号" sortable align="center">
            </el-table-column>
            <el-table-column prop="settingKey" label="设置Key" sortable align="center">
            </el-table-column>
            <el-table-column prop="settingName" label="设置名称" align="center" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="settingValue" label="设置值" align="center" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="createDate" label="创建时间" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center">
                　　　　<template slot-scope="scope">
                    　　　　　　<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
                    　　　　</template>
                　　</el-table-column>
        </el-table>

        <el-pagination style="margin: 20px;" background :current-page="list.pageNum" @current-change="pageChange"
            layout="total, sizes, prev, pager, next, jumper" :total="list.total" @size-change="handleSizeChange">
        </el-pagination>


        <!-- 编辑 -->
        <el-dialog title="编辑" :visible.sync="editDialogVisible" width="35%" style="text-align: center;"
        :close-on-click-modal="false">
            <div style="text-align: center;">
                <el-form ref="form" :model="form" size="medium">
                    <el-form-item label="设置名称:">
                        <el-col :span="8">
                            <el-input style="width: 300px;" v-model="form.settingName" placeholder="请输入设置名称" />
                        </el-col>
                    </el-form-item>

                    <el-form-item label="设置值:">
                        <el-col :span="10">
                            <el-input style="width: 300px;margin-left: 12px;" v-model="form.settingValue"
                                placeholder="请输入设置值" />
                        </el-col>
                    </el-form-item>
                    <el-form-item>
                        <el-button :loading="loading" type="primary" @click="toEdit()">提交</el-button>
                        <el-button @click="editDialogVisible = false">取 消</el-button>
                        <!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                searchInfo: {},
                list: {}, //列表
                editDialogVisible: false,
                page: { pageNum: 1, pageSize: 10 },
                form: {},
            };
        },

        methods: {
            empty() {
                this.searchInfo = {}
            },
            search() {
                this.page.pageNum = 1;
                this.getUserList()
            },
            //编辑弹框 
            editialogVisible(id) {
                this.getSysSettingInfoById(id);
                this.editDialogVisible = true;
            },
            getSysSettingInfoById(id) {
                this.$api.getSysSettingInfoById(id).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
                    if (res.state == 'success') {
                        this.form = res.data
                    }
                })
            },
            //编辑设置参数
            toEdit() {
                this.$api.editSysSettingInfoById(this.$encrypt(this.form)).then((res) => {
                    if (res.state == 'success') {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        });
                        this.editDialogVisible = false;
                        this.getUserList();
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            headClass() {
                return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
            },
            pageChange(data) {
                this.page.pageNum = data
                this.getUserList()
            },
            handleSizeChange(val) {
                this.page.pageSize = val
                this.getUserList()
            },
            getUserList() {
                this.loading = true
                let data = {
                    pageNum: this.page.pageNum,
                    pageSize: this.page.pageSize,
                    settingKey: this.searchInfo.settingKey,
                    settingName: this.searchInfo.settingName
                }
                this.$api.getAllSysSetting(this.$encrypt(data)).then((res) => {
                   
					res.data=JSON.parse(this.$decrypt(res.data)).data
                    if (res.state == 'success') {
                        this.list = res.data
                        this.loading = false
                    }
                })
            },
        },
        created() {
            this.getUserList();
        }
    };
</script>

<style>
</style>